var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "url(#pattern0_1210_2136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1210_2136",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1210_2136",
    transform: "matrix(0.0104167 0 0 0.00833333 0 0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1210_2136",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAESElEQVR4nO2dXYhVVRTHf5of4YxFZASl4leOBBGloS+99GSQloGC2FM99SjTF1EPYYUkPWRBij6EJOr4UT1kUC8iFBQU0UNIiGlBoGXSFORMjTs2rgG5OTP33rPOPWuds37wh8vMvfes9d+Hfc5ZZ519IQiCIAiCIAiCwB4zgNXAILAHOAmcAX4HRoEReX1G/rdH3rtaPht0wSxgA3AMGAZSl/oDOAo8Jt8ZTMFtwKvAbwVMn0j5O7cB82IU/k8/sB34qwTjW5W38TrQFwNxlTw9/NQD41t1DniUBnMj8FYFxrdqHzCHhjEf+NaA+eP6BriDhrAUOG3A9NSis8AANWcFcMGA2WkCnQeWU1PuBH40YHKaQj8DC6jhAdfSnJ+m0NfAbGrEbgOmpg71DjVhgwEzU5dah3PmOJn30yQXa66vmLcbMDEVVK5NueRW4E8DBiaF2pHLAt5rBsxLSnoFZ8wqqaScKtKv3u4nPF6SESPAQWCzlA36RAPyt0PynjK27apyeqwEA44AS9qsNR0tYftDOGGG3ArUSvxfucfbKc8AY4pxXAJuwAFrlPe8wQKxPKccyyocMKg87RTlA8V4tuKAvUrJjsh8XpTFigfmXNMyz0mlZA8qxjSkFNMJHKBV+9msGNMWpZhy85d5Liole5diTAOKF2Tm0Zpv+xVj6leK6TIOGDU4ADcpxZR3LvNcUkp2ucEpKDcBm+cHgwfhJ5RiOoUDPlNK9pBiTIeVYvoUB7yplOwosEwhniWKJwY7cMAmpWSTVDWL8qFiPBtxwELFhJNUNbvleeVYck+rC35RTHoMeLbLSqhmOTrn5Ib3lPe8JFXNdo4Jy5SnnXHlnNywrgQDkhyYh6S2s0Iu1vrl9RY529G6EHTdpDVb+a5YqljD0t/qigMGjEtK2o9DypqGUgV6BIdMd94Xmq7pD3VxM/56vGjAwFRQL+D8wevLBkxMXSqXMG7HOe8bMDJ1qRy7e+5WviJNPdIV4B5qgmZvTuqRNAqBZrhP9qjkSKuoGccNmJra1MfUkHudHAvGgJXUFA9nRPuoMYuAvw2YnCY572/nGQTX7DBgdJpAb9AAbjG6YMcFia0RPGXA8NSiJ2kQ04AvDJg+rq+ketso7pfnvyycdj5AQ3nbwADspMH0yUMPVd5smUvDebjCAVhfdfJW2F+B+bWo9WsxTxbM65X5572ugFIma3tYsnbVZNVLdvXA/HerTtL6EmenSjT/tPKzZ7VkZUn9nf/IjzoEbfByCQPwUjjfPtNlWQAt8z/33N1WFUsL/nzJuIaVFv1oJJsUBiA/ohpUVLDbGc4XZ6bM4Z2a/2XdFuCukgWyUkknSwrkhZoC5arpWBvmX/G2xKQntrUxAPk9QYnXBx9NYv4ncb5fPnOB765j/vfAzT3YfsDVDrtre4suKi3sEXTAg9JKmAt3D3XywUCPp0VBEARBEARBEAR44T+N2IkCDCW/YQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.77f3d030035ebdb4a99dadb39109ae2d.svg";
export { ForwardRef as ReactComponent };